import React, { useState, useEffect, useMemo, lazy, Suspense } from "react";
import { Headers } from "../../layouts/headers/headers";
import { MainContent } from "../../layouts/MainContent";
import { HeadersCentral } from "../../layouts/headers-central/headers-central";
import { PublicityList } from "../../components/datatable/PublicityList";
import { getPublicityAll } from "../../interpreter/publicity";
import PublicityFilter from "../../components/filters/filterPublicity";
import { FaPlus } from "react-icons/fa";

const UserModal = lazy(() => import("../../components/modals/profileUser"));
const AggPublicity = lazy(() => import("../../components/modals/aggPublicity"));
const UpdatedPublicity = lazy(() => import("../../components/modals/updatePublicity"));

const EMPTY_FILTERS = { commercialName: "", categoryId: "" };

const matchesPublicityFilters = (item, filters) => {
    const nameQuery = (filters.commercialName || "").trim().toLowerCase();
    const categoryId = String(filters.categoryId || "");
    const itemName = `${item.commercialName || ""} ${item.link || ""}`.toLowerCase();
    const itemCategoryId = String(item.id_category ?? item.category?.id ?? "");

    const matchesName = !nameQuery || itemName.includes(nameQuery);
    const matchesCategory = !categoryId || itemCategoryId === categoryId;

    return matchesName && matchesCategory;
};

const Publicity = () => {
    const [showDropdown, setShowDropdown] = useState(false);
    const [activeModal, setActiveModal] = useState(null);
    const [selectedPublicity, setSelectedPublicity] = useState(null);
    const [publicitys, setPublicitys] = useState([]);
    const [loading, setLoading] = useState(true);
    const [filters, setFilters] = useState(EMPTY_FILTERS);

    const fetchPublicity = async () => {
        try {
            setLoading(true);
            const data = await getPublicityAll();
            setPublicitys(Array.isArray(data) ? data : []);
        } catch (error) {
            console.error("Error al obtener publicidades:", error);
            setPublicitys([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchPublicity();
    }, []);

    const filteredPublicitys = useMemo(
        () => publicitys.filter((item) => matchesPublicityFilters(item, filters)),
        [publicitys, filters]
    );

    const openModal = (modalType, publicity) => {
        setSelectedPublicity(publicity);
        setActiveModal(modalType);
    };

    const closeModal = () => {
        setActiveModal(null);
        setSelectedPublicity(null);
    };

    return (
        <div className="flex h-screen">
            <Headers />

            <MainContent>
                <HeadersCentral
                    showDropdown={showDropdown}
                    setShowDropdown={setShowDropdown}
                    openModal={() => openModal("user")}
                />

                <main className="p-6 w-full">
                    <h1 className="text-2xl font-bold mb-7">Panel de Control de Publicidad</h1>
                    <PublicityFilter
                        filters={filters}
                        onFiltersChange={setFilters}
                        onClear={() => setFilters(EMPTY_FILTERS)}
                    />

                    <div className="mb-4">
                        <button
                            className="bg-red-600 hover:bg-red-700 text-white font-semibold py-2 px-4 rounded-lg shadow-md flex items-center gap-2 w-auto"
                            onClick={() => openModal("add")}
                        >
                            <FaPlus size={16} /> Agregar Publicidad
                        </button>
                    </div>

                    <div className="bg-white p-6 rounded-lg shadow-lg overflow-auto w-full">
                        <PublicityList
                            openModal={openModal}
                            publicitys={filteredPublicitys}
                            loading={loading}
                        />
                    </div>
                </main>
            </MainContent>
            <Suspense fallback={null}>
                {activeModal === "user" ? <UserModal isOpen={true} onClose={closeModal} /> : null}
                {activeModal === "add" ? (
                    <AggPublicity
                        isOpen={true}
                        onClose={closeModal}
                        onSuccess={fetchPublicity}
                    />
                ) : null}
                {activeModal === "reset" ? (
                    <UpdatedPublicity
                        isOpen={true}
                        onClose={closeModal}
                        publicity={selectedPublicity}
                        onSuccess={fetchPublicity}
                    />
                ) : null}
            </Suspense>
        </div>
    );
};

export default Publicity;
